import { formatUnits } from "viem";

/** wei string → DNM display, trailing zeros stripped. "9645000000000000000" → "9.645". */
export function formatDnm(wei: string): string {
  let value: bigint;
  try {
    value = BigInt(wei);
  } catch {
    return "0";
  }
  return formatUnits(value, 18)
    .replace(/(\.\d*?)0+$/, "$1")
    .replace(/\.$/, "");
}
